

window.addEventListener('DOMContentLoaded', function() {
  localization();
  header();
  heroSlider();
  titleGsap();
  textAppear();
  fixedVideo();
  smoothScroll('play');
  footerAccordion();
  cartDrawer();
  consultationDrawer();
  backInStockDrawer();
  marketDrawers();
  predictiveSearch();
  // getAllLangsInstructions();
  recentlyViewed();
  dynamicDrawer();
  specificationDrawer();
  seoText();
  jsUrlContactForm();
  initPhoneFields();
  judgeMe();
  payByParts();
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      ScrollTrigger.refresh();
    });
  });
})


function localization() {
  if (window.ISLocalization) {
    const locations = window.ISLocalization.countries;
    const block = document.querySelector('.localization-drawer');
    if (block) {
      const countrySelector = block.querySelector('[data-target="countrySelector"]');
      const countryBlock = block.querySelector('#countrySelector');
      const langSelector = block.querySelector('[data-target="languageSelector"]');
      const langBlock = block.querySelector('#languageSelector');
      const selectors = block.querySelectorAll('.select-button');
      const countries = block.querySelectorAll('[data-type="countrySelectorButton"');
      const langs = block.querySelectorAll('[data-type="languageSelectorButton"]');
      const close = block.querySelector('.close');
      close.addEventListener('click', function() {
        hide(block);
        hide(block.querySelector('.locale-detection'));
        triggerOverlay();
      })
      selectors.forEach(selector => {
        selector.addEventListener('click', function() {
          const target = block.querySelector(`#${selector.dataset.target}`);
          if (selector.classList.contains('active')) {
            hide(selector);
            hide(selector.nextElementSibling);
          } else {
            selectors.forEach(e => {
              hide(e);
              hide(e.nextElementSibling);
            })
            show(selector.nextElementSibling);
            show(this);
          }
        })
      })
      let url = '';
      countries.forEach(country => {
        country.addEventListener('click', function() {
          selectors.forEach(e => {
            hide(e);
            hide(e.nextElementSibling);
          })
          countrySelector.querySelector('.country-title').innerHTML = country.innerHTML;
          countrySelector.dataset.url = country.dataset.countryUrl;
          countrySelector.dataset.suffix = country.dataset.countrySuffix;
          countrySelector.dataset.defaultLocale = country.dataset.defaultLocale;
          // clean langs
          langBlock.innerHTML = '';
          const wrapper = document.createElement('div');
          wrapper.classList.add('selector-target-wrapper');
          langBlock.appendChild(wrapper);
          // get langs
          const countryObject = window.ISLocalization.countries.find(obj => obj.iso === country.dataset.countryIso);
          // build langs
          countryObject.langs.forEach((lang, index) => {
            wrapper.innerHTML += `
            <button data-type="languageSelectorButton" data-iso="${lang.iso}" class="button large with-icon icon-left secondary-white">
              <span class="country-flags country-flags--${lang.countryCode.toUpperCase()}"></span>
              ${lang.name}
            </button>
            `;
          })
          // console.log(langBlock);
          langSelector.querySelector('.lang-title').innerHTML = `
            <span class="country-flags country-flags--${countryObject.default.country_code.toUpperCase()}"></span>
            <span class="country-text">${countryObject.default.title}</span>
          `;
          langSelector.dataset.iso = countryObject.default.iso_code;
        })
      })
      window.addEventListener('click', function(evt) {
        if (evt.target.dataset.type === 'languageSelectorButton') {
          langSelector.querySelector('.lang-title').innerHTML = evt.target.innerHTML;
          langSelector.dataset.iso = evt.target.dataset.iso;
          selectors.forEach(e => {
            hide(e);
            hide(e.nextElementSibling);
          })
        }
        if (evt.target.dataset.type === 'langSwitcher') {
          show(block);
          triggerOverlay();
        }
      })
      const submit = block.querySelector('.locale-submit-button');
      submit.addEventListener('click', function() {
        const targetUrl = countrySelector.dataset.url;
        const targetSuffix = countrySelector.dataset.suffix || '';
        const targetDefaultLang = countrySelector.dataset.defaultLocale;
        const targetLang = langSelector.dataset.iso;

        // Bare path: drop Shopify root, country suffixes, and any known lang prefix
        let currentPath = window.ISLocalization.currentPath || '/';

        if (Shopify.routes.root && Shopify.routes.root !== '/') {
          const root = Shopify.routes.root.replace(/\/$/, '');
          if (currentPath === root || currentPath.startsWith(root + '/')) {
            currentPath = currentPath.slice(root.length) || '/';
          }
        }

        const marketSuffix = function(value) {
          const suffix = String(value || '').replace(/^\/|\/$/g, '').toLowerCase();
          if (!suffix) return '';
          return suffix.charAt(0) === '-' ? suffix : '-' + suffix;
        };
        const prefixes = new Set();
        window.ISLocalization.countries.forEach(function(c) {
          const suffix = marketSuffix(c.suffix);
          (c.langs || []).forEach(function(l) {
            const iso = l.iso ? String(l.iso).toLowerCase() : '';
            if (!iso) return;
            prefixes.add(iso);
            if (suffix) prefixes.add(iso + suffix);
          });
        });

        // Strip repeatedly so /pl/it/... collapses to /collections/...
        let stripped = true;
        while (stripped) {
          stripped = false;
          for (const p of prefixes) {
            if (!p) continue;
            if (currentPath === '/' + p) {
              currentPath = '/';
              stripped = true;
              break;
            }
            if (currentPath.startsWith('/' + p + '/')) {
              currentPath = currentPath.slice(p.length + 1);
              stripped = true;
              break;
            }
          }
        }

        if (currentPath.charAt(0) !== '/') currentPath = '/' + currentPath;

        // Shared domain with a suffix → one folder, /de-lu/...
        // Primary domain → no folder for its default language, /it/... for the others.
        let nextPath = currentPath;
        const suffix = marketSuffix(targetSuffix);
        const lang = String(targetLang || targetDefaultLang || '').toLowerCase();
        const defaultLang = String(targetDefaultLang || '').toLowerCase();
        if (suffix && lang) {
          nextPath = '/' + lang + suffix + nextPath;
        } else if (lang && lang !== defaultLang) {
          nextPath = '/' + lang + nextPath;
        }

        nextPath = nextPath.replace(/\/{2,}/g, '/');
        window.location.href = targetUrl + nextPath + window.location.search;
      })
    }
  }
}

// pay by parts
function payByParts() {
  const block = document.querySelector('.pay-by-parts');
  if (block) {
    const infoIcon = block.querySelector('.info-icon');
    const popup = document.querySelector('#pay-by-parts-popup');
    infoIcon.addEventListener('click', function() {
      toggle(popup);
      triggerOverlay();
    })
    const close = popup.querySelector('.close');
    close.addEventListener('click', function() {
      hide(popup);
      triggerOverlay();
    })
  }
}

function jsUrlContactForm() {
  const forms = document.querySelectorAll('#contact_form');
  if (forms.length > 0) {
    forms.forEach(form => {
      const hiddenElement = document.createElement('input');
      hiddenElement.type = 'hidden';
      hiddenElement.name = 'contact[page_url]';
      hiddenElement.value = window.location.href;
      form.appendChild(hiddenElement);
    })
  }
}

function sanitizePhoneInputValue(value) {
  return value.replace(/(?!^\+)[^\d]/g, '');
}

function initPhoneFields(root = document) {
  root.querySelectorAll('input[data-phone-field]:not([data-phone-init])').forEach((input) => {
    input.dataset.phoneInit = 'true';
    input.value = sanitizePhoneInputValue(input.value);

    input.addEventListener('input', () => {
      const sanitized = sanitizePhoneInputValue(input.value);
      if (sanitized !== input.value) {
        input.value = sanitized;
      }
    });
  });
}

window.themeKit = window.themeKit || {};
window.themeKit.initPhoneFields = initPhoneFields;

function judgeMe() {
  const block = document.querySelector('.jdgm-preview-badge');
  if (block) {
    const target = document.querySelector('#judgeme_product_reviews');
    block.addEventListener('click', function(e) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      // lenis.scrollTo(target, {
      //   offset: -200,
      // });
    })
  }
}

function seoText() {
  const blocks = document.querySelectorAll('.ks-seo-text');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const hideWrapper = block.querySelector('.hide-wrapper');
      const button = block.querySelector('.inline-button');
      button.addEventListener('click', function() {
        show(hideWrapper);
        hideWrapper.style.maxHeight = hideWrapper.scrollHeight + "px";
        button.style.display = 'none';
      })
    })
  }
}


function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

async function extractProduct(id) {
  url = `${Shopify.routes.root}search?type=product&q=id:${id}&section_id=main-search`, response = await fetch(url, { priority: "low" });
  const html = new DOMParser().parseFromString(await response.text(), "text/html");
  return html.querySelector('.collection-wrapper .slide-wrapper');
}

function convertToDecimalWithRegex(input) {
  const cleanedInput = input.replace(/[^\d,.-]/g, '').replace(',', '.');
  // console.log(cleanedInput);
  
  return parseFloat(cleanedInput);
}

function recentlyViewed() {
  var __accessCheck = (obj, member, msg) => {
    if (!member.has(obj))
      throw TypeError("Cannot " + msg);
  };
  var __privateGet = (obj, member, getter) => {
    __accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
  };
  var __privateAdd = (obj, member, value) => {
    if (member.has(obj))
      throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
  };
  var __privateSet = (obj, member, value, setter) => {
    __accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
  };
  var __privateMethod = (obj, member, method) => {
    __accessCheck(obj, member, "access private method");
    return method;
  };
  function extractSectionId(element) {
    element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
    return element.id.replace("shopify-section-", "");
  }
  var _isLoaded, _searchQueryString, searchQueryString_get, _loadProducts, loadProducts_fn;
  var RecentlyViewedProducts = class extends HTMLElement {
    constructor() {
      super(...arguments);
      __privateAdd(this, _searchQueryString);
      __privateAdd(this, _loadProducts);
      __privateAdd(this, _isLoaded, false);
    }
    connectedCallback() {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(__privateMethod(this, _loadProducts, loadProducts_fn).bind(this), { timeout: 1500 });
        // console.log('first');
      } else {
        __privateMethod(this, _loadProducts, loadProducts_fn).call(this);
        // console.log('second');
      }
    }
  };
  _isLoaded = new WeakMap();
  _searchQueryString = new WeakSet();
  searchQueryString_get = function() {
    const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
    if (this.hasAttribute("exclude-id")) {
      items.delete(parseInt(this.getAttribute("exclude-id")));
    }
    return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
  };
  _loadProducts = new WeakSet();
  loadProducts_fn = async function() {
    if (__privateGet(this, _isLoaded)) {
      return;
    }
    __privateSet(this, _isLoaded, true);
    const section = this.closest(".shopify-section");
    const isDewaltStyle =
      this.getAttribute("data-dewalt-style") === "true" ||
      section?.classList.contains("recently-viewed--dewalt") ||
      document.body.classList.contains("dewalt") ||
      document.documentElement.classList.contains("dewalt");
    if (isDewaltStyle) {
      this.setAttribute("data-brand-filter", "dewalt");
      this.setAttribute("data-dewalt-style", "true");
    }
    const brandFilter = this.getAttribute("data-brand-filter");
    const dewaltParam = brandFilter === "dewalt" || isDewaltStyle ? "&dewalt=1" : "";
    const query = encodeURIComponent(__privateGet(this, _searchQueryString, searchQueryString_get));
    const url = `${Shopify.routes.root}search?type=product&q=${query}&section_id=${extractSectionId(section)}${dewaltParam}`;
    const response = await fetch(url, { priority: "low" });
    
    const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
    if (recentlyViewedProductsElement.querySelector("swiper-slide")) {
      this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
      section.classList.add("recently-viewed--ready");
      document.documentElement.classList.remove("has-recently-viewed-pending");
      const slider = this.querySelector('.recent-list-slider');
      if (slider) {
        const isDewalt = Boolean(
          this.getAttribute("data-dewalt-style") === "true" ||
          section.querySelector('.recently-viewed-inner--dewalt') ||
          section.classList.contains('recently-viewed--dewalt') ||
          document.body.classList.contains('dewalt')
        );
        const spaceDesktop = isDewalt ? 20 : 0;
        const spaceMobile = isDewalt ? 12 : 0;
        const swiperParams = {
          slidesPerView: 3,
          navigation: {
            nextEl: section.querySelector('.next'),
            prevEl: section.querySelector('.prev'),
          },
          breakpoints: {
            1280: {
              slidesPerView: 4,
              slidesPerGroup: 1,
              spaceBetween: spaceDesktop,
            },
            768: {
              slidesPerView: 2,
              slidesPerGroup: 1,
              spaceBetween: spaceDesktop,
            },
            0: {
              slidesPerView: 1.2,
              slidesPerGroup: 1,
              spaceBetween: spaceMobile,
            }
          }
        };
        if (!isDewalt) {
          swiperParams.pagination = {
            el: section.querySelector('progress-bar'),
            type: 'progressbar',
          };
        }
        initSwiperContainer(slider, swiperParams);
      }
    } else {
      document.documentElement.classList.remove("has-recently-viewed-pending");
      section.remove();
    }
  };
  if (!window.customElements.get("recently-viewed-products")) {
    window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
  }
}

// Utility

function initSwiperContainer(container, params) {
  if (!container) return;
  const defaultMods = window.__DEFAULT_SWIPER_MODULES__;
  const injectStyles = window.__SWIPER_ELEMENT_INJECT_STYLES__;
  const merged = { watchOverflow: true, ...params };
  if (Array.isArray(defaultMods) && defaultMods.length) {
    merged.modules = [...defaultMods, ...(params.modules || [])];
  }
  if (Array.isArray(injectStyles) && injectStyles.length) {
    merged.injectStyles = [...injectStyles, ...(params.injectStyles || [])];
  }
  Object.assign(container, merged);
  container.initialize();
}

window.themeKit.initSwiperContainer = initSwiperContainer;

function titleGsap() {
  const titles = document.querySelectorAll('.section-wrapper .title-wrapper');
  if (titles.length > 0) {
    titles.forEach(title => {
      if (title.querySelector('.title')) {
        const heading = title.querySelector('.title');
        const trigger = {
          trigger: title,
            start: '80px 100%'
        };
        gsap.from(heading, {
          scrollTrigger: trigger,
          y: '100%',
          duration: 1.5,
          ease: 'power4.out'
        })
      }
    })
  }
}

// Desktop-only smooth scroll. Never enable on mobile viewports (incl. DeWalt
// iOS / iPad) — fine-pointer devices can still match hover MQ in Safari.
const lenisEnabled =
  window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
  !window.matchMedia('(max-width: 768px)').matches;
let lenis = null;
let lenisLoadPromise = null;
let lenisDesiredState = 'play';
gsap.registerPlugin(ScrollTrigger);

let lenisScrollOff = null;
let lenisRafCb = null;

function loadLenis() {
  if (!lenisEnabled) return Promise.resolve(null);
  if (lenis) return Promise.resolve(lenis);
  if (lenisLoadPromise) return lenisLoadPromise;

  const scriptUrl = window.themeKit && window.themeKit.lenisScript;
  if (!scriptUrl) return Promise.resolve(null);

  lenisLoadPromise = new Promise(function (resolve) {
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.defer = true;
    script.onload = function () {
      if (typeof window.Lenis !== 'function') {
        resolve(null);
        return;
      }
      lenis = new window.Lenis();
      window.themeKit.lenis = lenis;
      resolve(lenis);
    };
    script.onerror = function () {
      lenisLoadPromise = null;
      resolve(null);
    };
    document.head.appendChild(script);
  });

  return lenisLoadPromise;
}

function applyLenisState(instance, state) {
  if (!instance) return;
  if (state === 'play') {
    instance.start();
    if (!lenisScrollOff) {
      lenisScrollOff = instance.on('scroll', ScrollTrigger.update);
    }
    if (!lenisRafCb) {
      lenisRafCb = function lenisRaf(time) {
        instance.raf(time * 1000);
      };
      gsap.ticker.add(lenisRafCb);
      gsap.ticker.lagSmoothing(0);
    }
  } else if (state === 'stop') {
    if (lenisScrollOff) {
      lenisScrollOff();
      lenisScrollOff = null;
    }
    if (lenisRafCb) {
      gsap.ticker.remove(lenisRafCb);
      lenisRafCb = null;
    }
    instance.stop();
  }
}

function smoothScroll(state) {
  lenisDesiredState = state;
  loadLenis().then(function (instance) {
    applyLenisState(instance, lenisDesiredState);
  });
}

window.themeKit = window.themeKit || {};
window.themeKit.smoothScroll = smoothScroll;
window.themeKit.loadLenis = loadLenis;
window.themeKit.lenis = null;

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  // Product sticky nav owns its own smooth-scroll + offset (section-product.js).
  // Dual handlers on iOS cancel each other when Lenis is off.
  if (anchor.closest('.product-nav')) return;

  anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
          if (lenisEnabled) {
            loadLenis().then(function (instance) {
              if (instance) {
                instance.scrollTo(targetElement);
              } else {
                targetElement.scrollIntoView({ behavior: 'smooth' });
              }
            });
          } else {
            targetElement.scrollIntoView({ behavior: 'smooth' });
          }
      } else {
          console.warn(`Element with id "${targetId}" not found`);
      }
  });
});

// Header

function header() {
  const header = document.querySelector('header');
  const menu = header.querySelector('.main-menu');
  
  if (menu && header) {
    const menuDrawer = document.querySelector('.main-menu-drawer');
    let menuWrapper = header.querySelector('.menu-wrapper') || menuDrawer.querySelector('.menu-wrapper');
    if (!menuWrapper) return;
    if (menuWrapper.parentElement !== menuDrawer) {
      menuDrawer.appendChild(menuWrapper);
    }
    const links = menu.querySelectorAll('div.menu-link');
    const core = menuWrapper.querySelector('.first-level-wrapper[data-slug="core"]');
    const coreLinks = core.querySelectorAll('div.link');
    const innerLinks = menuWrapper.querySelectorAll('li.link[data-inner-slug]');
    links.forEach(link => {
      link.addEventListener('click', function(){
        setTimeout(function() {
          menuWrapper.classList.toggle('active');
          if (menuWrapper.classList.contains('active')) {
            activatePopupA11y(menuWrapper);
          } else {
            deactivatePopupA11y(menuWrapper);
          }
          triggerOverlay();
        }, 200);
        this.dataset.slug ? menuWrapper.querySelector(`.first-level-wrapper .link[data-slug="${this.dataset.slug}"]`).click() : null;
        
      })
    });
    const close = menuWrapper.querySelectorAll('.close');
    close.forEach(e => {
      e.addEventListener('click', function() {
        const secondLevel = menuWrapper.querySelector('.second-level');
        const menus = menuWrapper.querySelectorAll(`.first-level-wrapper`);
        menus.forEach(e => {
          e.classList.remove('active');
        })
        hide(menuWrapper);
        fadeOut(secondLevel, 300);
        triggerOverlay();
      })
    });

    const back = menuWrapper.querySelectorAll('.back');
    back.forEach(e => {
      e.addEventListener('click', function(){
        const menuTarget = this.closest('.first-level-wrapper');
        const secondLevel = menuWrapper.querySelector('.second-level');
        menuTarget ? menuTarget.classList.remove('active') : null;
        menuTarget ? core.classList.remove('active') : null;
        fadeOut(secondLevel, 300);
      })
    })

    const deepBack = header.querySelectorAll('.deep-back');
    deepBack.forEach(e => {
      e.addEventListener('click', function() {
        fadeOut(e.closest('.second-level'), 300);
      })
    })

    coreLinks.forEach(link => {
      link.addEventListener('click', function() {
        const menuTarget = menuWrapper.querySelector(`.first-level-wrapper[data-slug="${this.dataset.slug}"]`);
        menuTarget.classList.add('active');
        core.classList.add('active');
      })
    })
    innerLinks.forEach(link => {
      link.addEventListener('click', function() {
        const secondLevel = menuWrapper.querySelector('.second-level');
        const menuTarget = secondLevel.querySelector(`[data-slug="${this.dataset.innerSlug}"]`);
        const allTargets = secondLevel.querySelectorAll(`[data-slug]`);
        var slug = this.dataset.innerSlug;
        secondLevel.style.display === 'block' ? null : fadeIn(secondLevel, 300, 'block');        
        allTargets.forEach(e => {
          if (e.dataset.slug !== slug) {
            fadeOut(e, 300);
          } else {
            fadeIn(menuTarget, 300, 'block');
          }
        })
      })
    })
    const insideSection = header.querySelector('.header-wrapper');
    const isDewaltHeader = header.classList.contains('header-dewalt');

    if (isDewaltHeader) {
      dewaltHeaderScroll(header);
    } else if (insideSection) {
    let prevScroll = window.scrollY;
    prevScroll > insideSection.clientHeight ? () => {
      show(insideSection);
      setTimeout(() => {
        insideSection.style.transition = 'var(--tr)';
    }, 300)} : null;
    window.addEventListener('scroll', function(evt) {
      let currentScroll = window.scrollY;
      // console.log(insideSection.clientHeight);
      if (this.window.scrollY > insideSection.clientHeight) {
        header.style.minHeight = insideSection.clientHeight + 'px';
        if (currentScroll > prevScroll) {
          insideSection.style.transform = 'translateY(-100%)';
          const sticked = document.querySelector('.product-nav.sticked');
          if (sticked) {
            // console.log(sticked);
            sticked.style.transform = 'translateY(0%)';
          }
        } else {
          insideSection.style.transform = 'translateY(0)';
          const sticked = document.querySelector('.product-nav.sticked');
          if (sticked) {
            sticked.style.transform = `translateY(${header.clientHeight}px)`;
          }
        }
        this.setTimeout(() => {
          show(insideSection);
          insideSection.style.transition = 'var(--tr)';
        }, 100)
        
        prevScroll = currentScroll;
      }
      if (this.window.scrollY < 1) {
        hide(insideSection);
        this.setTimeout(() => {
          insideSection.style.transition = 'none';
        }, 100)
      }
    })
    }
  }
}

function dewaltHeaderScroll(header) {
  if (!header || !header.classList.contains('header-dewalt')) return;

  const mobileQuery = window.matchMedia('(max-width: 768px)');
  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateScrollState = () => {
    const currentY = window.scrollY;
    const isMobile = mobileQuery.matches;

    if (isMobile) {
      header.classList.remove('is-scrolled');

      if (currentY <= 8) {
        header.classList.remove('is-header-hidden');
      } else if (currentY > lastScrollY + 4) {
        header.classList.add('is-header-hidden');
      } else if (currentY < lastScrollY - 4) {
        header.classList.remove('is-header-hidden');
      }
    } else {
      header.classList.remove('is-header-hidden');

      if (currentY <= 8) {
        header.classList.remove('is-scrolled');
      } else if (currentY > lastScrollY + 4) {
        header.classList.add('is-scrolled');
      } else if (currentY < lastScrollY - 4) {
        header.classList.remove('is-scrolled');
      }
    }

    lastScrollY = currentY;
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  };

  const onResize = () => {
    if (!mobileQuery.matches) {
      header.classList.remove('is-header-hidden');
    }
    updateScrollState();
  };

  updateScrollState();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  dewaltMobileNav();
}

function dewaltMobileNav() {
  const navSection = document.querySelector('.header-dewalt-mobile-nav-section');
  const nav = document.querySelector('.dewalt-mobile-nav');
  if (!nav) return;

  /* Escape header-wrapper transform containing block so bottom bar stays visible */
  if (navSection && navSection.parentElement !== document.body) {
    document.body.appendChild(navSection);
  }

  nav.querySelectorAll('[data-dewalt-menu-slug]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const slug = btn.dataset.dewaltMenuSlug;
      if (!slug) return;
      const target = document.querySelector(
        `.dewalt-main-menu .menu-link[data-slug="${slug}"]`
      );
      if (target) target.click();
    });
  });
}

// Hero

function heroSlider() {
  const sliders = document.querySelectorAll('.hero-slider');
  if (sliders.length > 0) {
    sliders.forEach(slider => {
      const swiperParams = {
        slidesPerView: 1,
        navigation: {
          nextEl: slider.nextElementSibling.querySelector('.next'),
          prevEl: slider.nextElementSibling.querySelector('.prev'),
        },
        pagination: {
          el: slider.nextElementSibling.querySelector('progress-bar'),
          type: 'progressbar',
        },
      };
      initSwiperContainer(slider, swiperParams);
    })
  }
}

// Text appear

function textAppear() {
  const blocks = document.querySelectorAll('.text-appear');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const title = block.querySelector('.appear-title');
      const subtitle = block.querySelector('.appear-subtitle');
      gsap.to(title, {
        scrollTrigger: {
          trigger: title,
          start: '0% 70%',
          // markers: true
        },
        y: 0,
        duration: 2,
        ease: 'power4.out'
      })
      gsap.to(subtitle, {
        scrollTrigger: {
          trigger: subtitle,
          start: '0% 50%',
          // markers: true
        },
        y: 0,
        duration: 2,
        ease: 'power4.out'
      })
    })
  }
}

// Fixed video

function fixedVideo() {
  const blocks = document.querySelectorAll('.fixed-video');
  blocks.forEach(block => {
      const wrapper = block.querySelector('.video-wrapper');
      if (wrapper) {
        const animation = gsap.timeline({
          scrollTrigger: {
            trigger: block.querySelector('.video-wrapper'),
            pinSpacing: false,
            pin: true,
            // markers: true,
            start: 'bottom bottom',
            scrub: 0.5,
            anticipatePin: 1,
            end: () => window.innerWidth > 1024 ? `+=${block.offsetHeight}` : `+=${block.querySelector('video').offsetHeight}`
          } 
        })
      }
  })
}

// footer-accordion

function footerAccordion() {
  const blocks = document.querySelectorAll('.section-footer-main .accordion');
  if (blocks.length > 0) {
    blocks.forEach(block => {
      const items = block.querySelectorAll('.have-childs');
      const active = block.querySelector('.active');
      if (active) {
        active.querySelector('.second-wrapper').style.maxHeight = `${active.querySelector('.second-level').clientHeight}px`;
      }
      items.forEach(item => {
        item.addEventListener('click', function() {
          const currentActive = block.querySelector('.active');
          if (currentActive) {
            if (currentActive === this.parentElement) {
              // console.log('test');
              hide(this.parentElement);
              this.nextElementSibling.style.maxHeight = '0px';
            } else {
              hide(currentActive);
              currentActive.querySelector('.second-wrapper').style.maxHeight = '0px';
              show(this.parentElement);
              this.nextElementSibling.style.maxHeight = `${this.nextElementSibling.querySelector('.second-level').clientHeight}px`;
            }
          } else {
            show(this.parentElement);
            this.nextElementSibling.style.maxHeight = `${this.nextElementSibling.querySelector('.second-level').clientHeight}px`;
          }
        })
      })
      if (window.innerWidth < 768) {
        const mobileMenus = document.querySelectorAll('.section-footer-main .footer-menu');
        mobileMenus.forEach(menu => {
          const button = menu.querySelector('.title');
          button.addEventListener('click', function() {
            if (this.parentElement.classList.contains('active')) {
              hide(this.parentElement);
              this.nextElementSibling.style.maxHeight = '0px';
            } else {
              show(this.parentElement);
              this.nextElementSibling.style.maxHeight = `${this.parentElement.querySelector('.simple-menu').clientHeight}px`;
            }
          })
        })
      }
    })
  }
}

// cart drawer

function addItemsToCart(items) {
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
  }).then(function (response) {
    return response.json();
  });
}

function renderDrawerCart(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const incomingCart = parsedHTML.querySelector('.main-cart-drawer .whole-wrapper');
  const incomingScript = incomingCart.querySelector('script');
    
  const cart = document.querySelector('.main-cart-drawer .whole-wrapper');
  if (incomingScript) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = incomingScript.innerHTML;
    cart.insertBefore(script, cart.firstChild);
  }
  cart.innerHTML = incomingCart.innerHTML;

  const drawerRoot = document.querySelector('.main-cart-drawer');
  if (document.body.classList.contains('dewalt')) {
    const incomingTitle = parsedHTML.querySelector('.main-cart-drawer .titles .s1');
    const title = document.querySelector('.main-cart-drawer .titles .s1');
    if (incomingTitle && title) {
      title.textContent = incomingTitle.textContent;
    }
  }

  if (drawerRoot && drawerRoot.classList.contains('active')) {
    const closeBtn = drawerRoot.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }
}

function withDewaltCartParam(url) {
  const nextUrl = new URL(url, window.location.origin);
  if (document.body.classList.contains('dewalt')) {
    nextUrl.searchParams.set('dewalt', '1');
  }
  return nextUrl.toString();
}

function renderHead(html) {
  const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  const incomingHead = parsedHTML.querySelector('.cart');
  const head = document.querySelector('.header-secondary .cart');
  if (head && incomingHead) {
    head.innerHTML = incomingHead.innerHTML;
  }

  const countEl = incomingHead && incomingHead.querySelector('[data-count]');
  const count = countEl ? countEl.getAttribute('data-count') : null;
  if (count !== null) {
    document.querySelectorAll('.dewalt-mobile-nav__cart-count').forEach((el) => {
      el.setAttribute('data-count', count);
      el.textContent = count;
    });
  }
}

function cartDrawer() {

  const drawer = document.querySelector('.cart-drawer-wrapper');
  if (!drawer) return;
  const close = drawer.querySelector('[data-cart-drawer-close], .close');
  const checkout = drawer.querySelector('.button-checkout');
  if (checkout) {
    checkout.addEventListener('click', function() {
      drawer.querySelector('form').submit();
    })
  }
  
  if (close) {
    close.addEventListener('click', function() {
      closeCartDrawer();
    })
  }

  renderRelated();
  // recommendations
  function renderRelated() {
    if (window.ISCartItems && window.ISCartItems.length > 0) {
      const section = document.querySelector('.main-cart-drawer .recommendations');
      // console.log(window.ISCartItems);    
      let recommendations = [];
      let uniqueRecommendationIds = new Set();
      const sectionId = document.querySelector('#mainCart') ? 'cart-static-recommendations' : 'cart-recommendations';
      let fetchPromises = window.ISCartItems.map(item => {
      return fetch(window.Shopify.routes.root + `recommendations/products?product_id=${item}&limit=10&section_id=${sectionId}&intent=related`)
        .then(response => response.text())
        .then((text) => {
            const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
            const elements = parsedHTML.querySelectorAll('.recommendation-product');
            elements.forEach(e => {
              const productId = e.getAttribute('data-id');
              if (productId && !uniqueRecommendationIds.has(productId) && !window.ISCartItems.includes(productId)) {
                uniqueRecommendationIds.add(productId);
                recommendations.push(e);
              }
            });
        });
      });
  
      Promise.all(fetchPromises)
      .then(() => {
        // console.log(recommendations);
        const div = document.createElement('div');
        recommendations.forEach(e => {
          div.appendChild(e);
        })
        if (section) {
          section.innerHTML = '';
          section.innerHTML = div.innerHTML;
          if (recommendations.length === 0) {
            section.closest('.recommendations-wrapper').style.display = 'none';
          }
          if (document.querySelector('#mainCart')) {
            const section = document.querySelector('#mainCart .recommendations');
            if (recommendations.length === 0) {
              section.closest('.recommendations-wrapper').style.display = 'none';
            } else {
              section.innerHTML = div.innerHTML;
            }
          }
        }
      })
      .catch(error => {
        console.error('Error fetching recommendations:', error);
      });
    }
  }
  
  

  // active links in drawer with section rendering

  window.addEventListener('click', function(evt) {
    if (evt.target.hasAttribute('data-render-section')) {
      evt.preventDefault();
      const sectionId = evt.target.closest('.main-cart-drawer').id;
      const loading = evt.target.closest('.main-cart-drawer').querySelector('.loading');
      loading.style.display = 'block';
      let url = new URL(evt.target.href);
      let params = new URLSearchParams(url.search);
      params.set('section_id', sectionId);
      if (document.body.classList.contains('dewalt')) {
        params.set('dewalt', '1');
      }
      url.search = params.toString();
      url = url.toString();
      fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        renderDrawerCart(html);
        renderHead(html);
        renderRelated();
        loading.style.display = 'none';
      });
    }

    if (evt.target.hasAttribute('data-related-add')) {
      hide(evt.target.querySelector('.icon'));
      show(evt.target.querySelector('.spinner'));
      let formData = {
        'items': [{
         'id': evt.target.dataset.id,
         'quantity': 1
         }]
       };
      const url = window.Shopify.routes.root + 'cart/add.js';
      let loading;
      if (!this.document.querySelector('#mainCart')) {
        loading = evt.target.closest('.main-cart-drawer').querySelector('.loading');
        loading.style.display = 'block';
      }
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((res) => {return res.json()})
      .then((data) => {
        if (document.querySelector('#mainCart')) {
          window.location.reload();
        } else {
          fetch(withDewaltCartParam(window.Shopify.routes.root + 'cart'))
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            renderDrawerCart(html);
            renderHead(html);
            renderRelated();
            loading.style.display = 'none';
            const cartRoot = document.querySelector('.main-cart-drawer');
            if (cartRoot) {
              announceCartDrawer(cartRoot.getAttribute('data-item-added'));
            }
          });
        }
      })
    }

    if (evt.target.id === 'BuyGiftKit') {
      // console.log(evt.target.dataset.giftId);
      hide(evt.target.querySelector('.icon'));
      show(evt.target.querySelector('.spinner'));
      let formData = {
        'items': [
          {
            'id': evt.target.dataset.id,
            'quantity': 1
          },
          {
            'id': evt.target.dataset.giftId,
            'quantity': 1
          }
        ]
      };
      const url = window.Shopify.routes.root + 'cart/add.js';
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((res) => {return res.json()})
      .then((data) => {
        fetch(withDewaltCartParam(window.Shopify.routes.root + 'cart'))
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          renderDrawerCart(html);
          renderHead(html);
          renderRelated();
          openCartDrawer({ announceAdded: true });
          show(evt.target.querySelector('.icon'));
          hide(evt.target.querySelector('.spinner'));
        });
      })
    }

    const collectionAddButton = evt.target.closest('[data-collection-add]');
    if (collectionAddButton) {
      hide(collectionAddButton.querySelector('.icon'));
      show(collectionAddButton.querySelector('.spinner'));
      const items = [{
        'id': collectionAddButton.dataset.id,
        'quantity': 1
      }];
      if (collectionAddButton.dataset.id2) {
        items.push({
          'id': collectionAddButton.dataset.id2,
          'quantity': 1
        });
      }

      (async function () {
        try {
          await addItemsToCart(items);

          const response = await fetch(withDewaltCartParam(window.Shopify.routes.root + 'cart'));
          const responseText = await response.text();
          const html = responseText;
          renderDrawerCart(html);
          renderHead(html);
          renderRelated();
          openCartDrawer({ announceAdded: true });
          show(collectionAddButton.querySelector('.icon'));
          hide(collectionAddButton.querySelector('.spinner'));
        } catch (error) {
          console.error('Error adding to cart:', error);
          show(collectionAddButton.querySelector('.icon'));
          hide(collectionAddButton.querySelector('.spinner'));
        }
      })();
    }

    const cartBubble = evt.target.closest('[data-cart-bubble]');
    if (cartBubble) {
      const countEl = cartBubble.querySelector('[data-count]');
      const count = countEl ? parseInt(countEl.getAttribute('data-count'), 10) : 0;
      if (!document.querySelector('#mainCart') && (count > 0 || cartBubble.closest('.dewalt-mobile-nav'))) {
        openCartDrawer();
      }
    }
  })
}

// consultation-drawer

function consultationDrawer() {
  const drawer = document.querySelector('.consultation-drawer');
  if (drawer) {
    const close = drawer.querySelector('.close');
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
    });
    window.addEventListener('click', function(evt) {
      if (evt.target.closest('[data-consultation]')) {
        evt.preventDefault();
        show(drawer);
        triggerOverlay();
      }
    });
  }

  const params = new URLSearchParams(window.location.search);
  if (!params.has('contact_posted')) return;

  if (drawer) {
    show(drawer);
    triggerOverlay();
  }

  params.delete('contact_posted');
  const query = params.toString();
  const nextUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
  window.history.replaceState({}, '', nextUrl);
}

function backInStockDrawer() {
  const drawer = document.querySelector('.back-in-stock');
  if (!drawer) return;

  const close = drawer.querySelector('.close');
  const form = drawer.querySelector('form');
  const companyId = window.themeVariables.settings.klaviyoKey;

  // === Utility ===
  const showDrawer = () => { show(drawer); triggerOverlay(); };
  const hideDrawer = () => { hide(drawer); triggerOverlay(); };

  // === Drawer events ===
  close.addEventListener('click', hideDrawer);

  window.addEventListener('click', (evt) => {
    if (evt.target.hasAttribute('data-back-in-stock')) {
      evt.preventDefault();
      drawer.dataset.variantId = evt.target.dataset.variant;
      showDrawer();
    }
  });

  // === Form submit ===
  form.addEventListener('submit', async (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    const spinner = drawer.querySelector('.spinner');
    show(spinner);

    const id = drawer.dataset.variantId;
    const fName = drawer.querySelector('#ContactForm-fname').value.trim();
    const lName = drawer.querySelector('#ContactForm-lname').value.trim();
    const email = drawer.querySelector('#ContactForm-email').value.trim();
    const phone = drawer.querySelector('#ContactForm-phone').value.trim();
    const locale = Shopify.locale + '-' + Shopify.country;

    if (!email && !phone) {
      alert('Please enter an email or phone number.');
      return;
    }

    const profileUrl = `https://a.klaviyo.com/client/profiles/?company_id=${companyId}`;
    const bisUrl = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`;

    // --- 1️⃣ Create or update the profile first ---
    const profileBody = {
      data: {
        type: 'profile',
        attributes: {
          email,
          phone_number: phone || undefined,
          first_name: fName || undefined,
          last_name: lName || undefined,
          locale: locale
        },
        meta: {
          patch_properties: {
            append: {
              language: Shopify.locale
            }
          }
        }
      }
    };

    try {
      const profileRes = await fetch(profileUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          Revision: '2025-10-15',
          'Content-Type': 'application/vnd.api+json'
        },
        body: JSON.stringify(profileBody)
      });

      if (!profileRes.ok && profileRes.status !== 202 && profileRes.status !== 204) {
        const text = await profileRes.text();
        console.error('Klaviyo profile error:', profileRes.status, text);
        throw new Error(`Profile update failed (${profileRes.status})`);
      }

      console.log(`Profile created/updated for ${email} (${locale})`);

      // --- 2️⃣ Then subscribe profile to Back-in-Stock ---
      const bisBody = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL', 'SMS'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  phone_number: phone || undefined
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${id}`
              }
            }
          }
        }
      };

      const bisRes = await fetch(bisUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          Revision: '2025-10-15',
          'Content-Type': 'application/vnd.api+json'
        },
        body: JSON.stringify(bisBody)
      });

      if (!bisRes.ok && bisRes.status !== 202 && bisRes.status !== 204) {
        const text = await bisRes.text();
        console.error('Klaviyo BIS error:', bisRes.status, text);
        throw new Error(`Back-in-Stock failed (${bisRes.status})`);
      }

      console.log('Back-in-Stock subscription accepted');
      // alert('You’ll be notified when this item is back in stock!');
      const message = drawer.querySelector('.success-message');
      hide(spinner);
      show(message);

    } catch (err) {
      console.error('Back-in-Stock workflow failed:', err);
      // alert('Something went wrong while subscribing. Please try again.');
    }
  });
}

function dynamicDrawer() {
  
  const buttons = document.querySelectorAll(`a[href^="#dynamicDrawer-"]`);
  if (buttons.length > 0) {
    buttons.forEach(button => {
      const id = button.href.split('#')[1];
      const drawer = document.querySelector(`#${id}`)?.parentElement;
      // console.log(drawer);
      
      if (drawer) {
        const close = drawer.querySelector('.close');
        close.addEventListener('click', function() {
          hide(drawer);
          triggerOverlay();
        })
        button.addEventListener('click', function(evt) {
          evt.preventDefault();
          show(drawer);
          triggerOverlay();
        })
      }
    })
  }
}

function specificationDrawer() {
  const button = document.querySelector(`[data-specs-drawer]`);
  const drawer = document.querySelector(`#main-specs-drawer`);
  if (button && drawer) {
    button.addEventListener('click', function(evt) {
      evt.preventDefault();
      show(drawer);
      triggerOverlay();
    })
    const close = drawer.querySelector('.close');
    close.addEventListener('click', function() {
      hide(drawer);
      triggerOverlay();
    })
  }
}

// market drawers

function marketDrawers() {
  const drawers = ['.delivery-drawer', '.payment-drawer'];
  drawers.forEach(e => {
    const drawer = document.querySelector(e);
    if (drawer) {
      const close = drawer.querySelector('.close')
      close.addEventListener('click', function() {
        hide(drawer);
        triggerOverlay();
      })
      window.addEventListener('click', function(evt) {
        if (evt.target.hasAttribute('data-market-drawer')) {
          const popup = evt.target.closest('.sibling').nextElementSibling;
          show(popup);
          triggerOverlay();
        }
      })
    }
  })
}

// search

function predictiveSearch() {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.closest('.search-drawer');
      this.input = this.querySelector('input[type="text"]');
      this.predictiveSearchResults = this.drawer
        ? this.drawer.querySelector('.search-results')
        : this.parentElement.querySelector('.search-results');
      this.suggestions = this.drawer
        ? this.drawer.querySelector('.suggestions')
        : this.parentElement.querySelector('.suggestions');
      this.erase = this.querySelector('.erase');
      this.closeButton = this.drawer
        ? this.drawer.querySelector('.search-drawer-dewalt__close, .close')
        : this.parentElement.parentElement.querySelector('.close');
      this.trigger = document.querySelector('#searchOpen');
      this.form = this.querySelector('form');
      this.isDewaltSearch = Boolean(this.closest('[data-dewalt-search]'));
      this.dewaltTag = this.closest('[data-dewalt-search]')?.dataset?.dewaltTag || 'dewalt';
      this.isKsSearch = Boolean(this.closest('[data-ks-search]')) && !this.isDewaltSearch;
      this.ksTag = this.closest('[data-ks-search]')?.dataset?.ksTag || 'konner-sohnen';
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.style.display = 'none';
      }

      this.input.addEventListener('input', this.debounce((event) => {
        this.input.value.length > 0 ? show(this.erase) : hide(this.erase);
        this.onChange(event);
      }, 300).bind(this));

      if (this.erase) {
        this.erase.addEventListener('click', () => {
          this.input.value = '';
          hide(this.erase);
          setTimeout(() => {
            this.input.focus();
          }, 100);
          this.close();
        });
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.close();
          hide(this.closest('.search-drawer'));
          triggerOverlay();
        });
      }

      if (this.trigger) {
        this.trigger.addEventListener('click', () => {
          if (!document.querySelector('#mainSearch')) {
            setTimeout(() => {
              this.input.focus();
            }, 100);
            show(this.closest('.search-drawer'));
            triggerOverlay();
          }
        });
      }

      if (this.form && this.isDewaltSearch) {
        this.form.addEventListener('submit', () => {
          const term = this.normalizeBrandTerm(this.input.value, this.dewaltTag);
          this.input.value = term ? `${term} tag:${this.dewaltTag}` : `tag:${this.dewaltTag}`;
        });
      } else if (this.form && this.isKsSearch) {
        this.form.addEventListener('submit', () => {
          const term = this.normalizeBrandTerm(this.input.value, this.ksTag);
          this.input.value = term ? `${term} tag:${this.ksTag}` : `tag:${this.ksTag}`;
        });
      }
    }

    normalizeBrandTerm(value, tag) {
      return String(value || '')
        .replace(new RegExp(`\\btag:${tag}\\b`, 'gi'), '')
        .trim();
    }

    normalizeDewaltTerm(value) {
      return this.normalizeBrandTerm(value, this.dewaltTag);
    }

    onChange() {
      const brandTag = this.isDewaltSearch ? this.dewaltTag : this.isKsSearch ? this.ksTag : '';
      const searchTerm = brandTag
        ? this.normalizeBrandTerm(this.input.value, brandTag)
        : String(this.input.value || '').trim();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      let scopedTerm = searchTerm;
      if (this.isDewaltSearch) {
        scopedTerm = `${searchTerm} tag:${this.dewaltTag}`;
      } else if (this.isKsSearch) {
        scopedTerm = `${searchTerm} tag:${this.ksTag}`;
      }
      const sectionId = this.isDewaltSearch ? 'predictive-search-dewalt' : 'predictive-search';
      const resourceType = this.isDewaltSearch ? 'product' : 'product,collection';
      const url =
        `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(scopedTerm)}` +
        `&resources[options][unavailable_products]=show` +
        `&resources[type]=${resourceType}` +
        `&section_id=${sectionId}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const sectionSelector = this.isDewaltSearch
            ? '#shopify-section-predictive-search-dewalt'
            : '#shopify-section-predictive-search';
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const section =
            parsed.querySelector(sectionSelector) ||
            parsed.querySelector('[id^="shopify-section-predictive-search"]');
          const resultsMarkup = section ? section.innerHTML : '';
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.style.display = 'block';
      }
      if (this.drawer) {
        this.drawer.classList.add('has-results');
      }
      if (this.suggestions) {
        this.suggestions.style.display = 'none';
      }
    }

    close() {
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.style.display = 'none';
        this.predictiveSearchResults.innerHTML = '';
      }
      if (this.drawer) {
        this.drawer.classList.remove('has-results');
      }
      if (this.suggestions) {
        this.suggestions.style.display = this.isDewaltSearch ? 'flex' : 'flex';
      }
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  customElements.define('predictive-search', PredictiveSearch);
}

window.addEventListener('click', function(evt) {

  // lang switcher

  

  // featured collections section

  if (evt.target.dataset.id === 'featColTrigger') {
    const currentButton = evt.target.parentElement.querySelector('.active');
    const currentSection = evt.target.parentElement.nextElementSibling.querySelector('.active');
    const targetButton = evt.target;
    const targetSection = evt.target.parentElement.nextElementSibling.querySelector(`#section-${targetButton.dataset.index}`);
    if (currentButton != targetButton) {
      hide(currentButton);
      hide(currentSection);
      show(targetButton);
      show(targetSection);
    }
  }

  if (evt.target.dataset.id !== 'shareButtons') {
    const shareButtons = document.querySelector('.share-buttons');
    shareButtons ? hide(shareButtons) : null;
  }

  if (document.querySelector('#staticFilters')) {
    if (!evt.target.closest('.filter-group')) {
      this.document.querySelectorAll('[data-id="staticButton"]').forEach(e => {
        hide(e);
        hide(e.nextElementSibling);
      })
    }
  }

  if (!evt.target.closest('.localization-box')) {
    this.document.querySelectorAll('.localization-box .select-button').forEach(e => {
      hide(e);
      hide(e.nextElementSibling);
    })
  }

  if (this.document.querySelector('#giftSelector')) {
    if (!evt.target.closest('#giftSelector') && !evt.target.closest('#giftButton')) {
      hide(this.document.querySelector('#giftSelector'));
    }
  }
  

})


